import * as CL from '@design-system/component-library';
import { elisaKukaSoittaaMsg, t } from '../../common/i18n';
import { isSpeedUpgradeOffer } from './SubscriptionUtils';
import type { SubscriptionCardWithModel } from './types';

import './ProductVariantSelection.scss';

const ProductVariantSelectionTooltip = ({ speedUpgradeText }: { speedUpgradeText: string }) => (
  <div>
    <h5>{t.GJ02('Select additional feature to include in subscription')}</h5>
    <div className="ds-margin-vertical--2">
      <strong>{t.ZKZZ(elisaKukaSoittaaMsg)}</strong>
      <p>
        {t.UWU6(
          'The service automatically displays the caller’s name information on your phone, even if the number is not saved in your address book. Read more about the Kuka Soittaa service.'
        )}
      </p>
    </div>
    <div className="ds-margin-vertical--2">
      <strong>{speedUpgradeText}</strong>
      <p>{t.UWU8('Increase your subscription speed for even more efficient and seamless work.')}</p>
    </div>
  </div>
);

export interface ProductVariantSelectionProps {
  subscriptionCard?: SubscriptionCardWithModel;
  onSelectOffer?: (guid: string, name: string) => void;
}

export const ProductVariantSelection = ({ subscriptionCard, onSelectOffer }: ProductVariantSelectionProps) =>
  subscriptionCard && 'offers' in subscriptionCard && (subscriptionCard.offers?.length ?? 0) > 1 ? (
    <div className="product-variant-selection">
      <div className="radio-container">
        <CL.RadioGroup
          label={t.N1X5('Select one additional feature')}
          i18n_radiogroup_infoText={
            <ProductVariantSelectionTooltip
              speedUpgradeText={subscriptionCard?.offers?.find(offer => isSpeedUpgradeOffer(offer.guid))?.text || ''}
            />
          }
        >
          {subscriptionCard?.offers?.map((offer, index) => (
            <CL.RadioV2
              key={`product-variant-key-${index}`}
              id={`product-variant-${index}`}
              label={offer.text}
              onChange={e => onSelectOffer?.(e.target.value, subscriptionCard?.cardName || '')}
              value={offer.guid}
              checked={subscriptionCard?.selectedOffer === offer.guid}
            />
          ))}
        </CL.RadioGroup>
      </div>
    </div>
  ) : null;
